import React from 'react';
import {Row, Col, Media} from 'react-bootstrap';
import {FaInfoCircle, FaShare,FaEnvelope, FaHome, FaMale} from 'react-icons/fa';
import {MORSContainer, HeaderButton, HeaderDiv, NavHeader, NavSpan, 
    ContactContainer, NavBody, NavContent, FooterContainer, FooterCopyright,
    FooterSMDiv,VersionText} from '../../theme/MorsTheme';
import HeaderLogo from '../Components/HeaderLogo';
import Login from '../Components/Login';
import {DEV_REV} from '../../resources/constant';
const IndexLayout = (props) => 
(

    <MORSContainer> 
        <Row>
            <Col as={Col} md={3} sm={3} xs={12} >
                <Row noGutters>
                    <Media>                
                        <HeaderLogo/>                
                    </Media>   
                </Row>
                <Row noGutters className="d-none d-sm-block">
                    <NavHeader>
                        <NavSpan>
                            NAVIGATE
                        </NavSpan>                
                    </NavHeader>
                </Row>
                <Row noGutters className="d-none d-sm-block">
                    <Col as={Col}>
                    <NavBody>                                                  
                        <NavContent>                                 
                            <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                            <a href="https://www.bdo.com.ph/personal/ebanking"><span style={{color:'#FFB20C', fontWeight:'bold'}}>eBanking</span></a>                                                                                    
                        </NavContent>  
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/personal/accounts"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Accounts</span></a>                                                                                    
                    </NavContent>  
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/trust-and-investments"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Trust and Investment</span></a>                                                                                    
                    </NavContent>  
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/personal/loans"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Loans</span></a>                                                                                    
                    </NavContent> 
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/personal/credit-debit-cards"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Credit Cards</span></a>                                                                                    
                    </NavContent>
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/personal/remittance-services"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Remittance Services</span></a>                                                                                    
                    </NavContent>
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/personal/insurance"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Insurance</span></a>                                                                                    
                    </NavContent>
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/personal/rewards"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Rewards</span></a>                                                                                    
                    </NavContent>
                    <NavContent>                                 
                        <img alt="thumbnail" src="media/menu-arrow.png" style={{marginRight:'4px'}}/>
                        <a href="https://www.bdo.com.ph/private-bank-home"><span style={{color:'#FFB20C', fontWeight:'bold'}}>Private Bank</span></a>                                                                                    
                    </NavContent>
                </NavBody>
                </Col>
                </Row>
            </Col>
            <Col as={Col} md={9} sm={9} xs={12}>
                <Row noGutters align="right">
                    <Col as={Col} className="d-none d-md-block">                    
                        <a href={'http://www.bdo.com.ph/personal'}>
                            <HeaderButton>
                                <span><font style={{color:'white',margin:'5px'}}> <span style={{fontSize:'12px'}}><FaHome/></span> GO BACK TO BDO.COM.PH</font></span>                                                                                                                
                            </HeaderButton>
                        </a>                                                                
                    </Col>
                </Row>
                <Row noGutters align="right" style={{padding:'5px 20px 0px 0px'}}>
                    <Col as={Col} className="d-none d-md-block">
                    <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                        <span style={{color:'black',fontSize:'12px'}}><FaHome/></span>                        
                    </a>
                    
                    <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                        <span style={{color:'black',fontSize:'12px'}}><FaEnvelope/></span>                        
                    </a>
                    <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                        <span style={{color:'black',fontSize:'12px'}}>
                        <FaInfoCircle/>
                        </span>                        
                    </a>
                    <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                        <span style={{color:'black', fontSize:'12px'}}><FaShare/></span>                        
                    </a>                
                    </Col>
                </Row>
                
                <Row noGutters style={{paddingTop:'60px',height:'180px'}} className="d-none d-md-block">                                            
                    <HeaderDiv style={{marginLeft:'93px', paddingTop:'6px', opacity: 0.9}} >                                                
                        <hr style={{height:'2px',border:'none',backgroundColor:'#FFB20C'}}/>                         
                        <span style={{color:'white', fontSize:'32px', fontWeight:'bold'}}>
                        Merchant Online Reporting System
                        </span>                                            
                    </HeaderDiv>    
                    
                </Row>

                <Row noGutters style={{paddingTop:'18px'}}>
                    <Col md={6} sm={6} style={{paddingLeft:'15px', paddingRight:'15px'}}>                       
                        <Login updateStates={props.updateStates} onLogin={props.onLogin}{...props} />                                            
                    </Col>
                    <Col md={6} sm={5} className="d-none d-sm-block">                                                  
                        <ContactContainer>
                            <Row noGutters>                                                        
                                <Col md={5} sm={7} style={{paddingLeft:'25px', fontSize:'10px', color:'#004080'}}>                                
                                <div style={{paddingTop:'30px', paddingBottom:'10px', color:'#004080', fontSize:'18px', fontWeight:'bold'}}>Contact Us</div>			
                                    <div>Metro Manila</div>
                                    <div>PLDT</div>
                                    <div>Globe</div>
                                    <br/>
                                    <div>Domestic Toll-Free</div>
                                    <div>PLDT</div>
                                    <div>Globe</div>
                                    <div>Fax</div>
                                    <div>Email add</div>                                     
                                </Col>
                                <Col md={4} sm={5} style={{paddingTop:'80px'}}>                                         
                                    <div style={{fontStyle:'Arial', fontSize:'10px'}}>8702-6900</div>
                                    <div style={{fontStyle:'Arial', fontSize:'10px'}}>7909-6900</div>
                                    <br/>
                                    <div style={{fontStyle:'Arial', paddingTop:'25px', fontSize:'10px'}}>1-800-10-8702-6900</div>
                                    <div style={{fontStyle:'Arial', fontSize:'10px'}}>1-800-8-7909-6900</div>
                                    <div style={{fontStyle:'Arial', fontSize:'10px'}}>632 8727-2104</div>
                                    <div style={{fontStyle:'Arial', fontSize:'10px'}}>merchantsvcs@bdo.com.ph</div>                                                                                                       
                                </Col>
                                </Row>
                        </ContactContainer>                                                
                    </Col>                                     
                    </Row>   
                    <Row noGutters>
                        <Col className="d-none d-sm-block">
                        <FooterContainer>  
                            {/* Monina added - && props.attempt !== '0' */}
                            {(props.attempt !=='' && props.attempt !== '0') ? 
                            <div align="left" style={{fontSize:'12px'}}>
                                <Row>
                                    <Col>
                                        <Row style={{paddingLeft:'12px'}}>
                                            <Col><span><b>Invalid Attempts : </b></span>{props.attempt}</Col>
                                            <Col><span><b>Last Login : </b></span>{props.lastLogin}</Col>
                                        </Row>
                                    </Col>
                                    <Col></Col>
                                </Row>                                                                 
                            </div> : ''}
                                
                            
                        
	            <div>
                   <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/about-bdo/business-operation" >
                    About BDO
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/corporate-governance">
                    Corporate Governance
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/investor-relations/investment-credit-ratings-information">
                    Investor Relations
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/contact-us">
                    Contact Us
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/careers">
                    Careers
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/news-and-articles">
                    Press Room
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/site-map">
                    Site Map
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/privacy-policy">
                    Privacy Policy
                    </a>
                    <a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/terms-and-conditions">
                    Terms and Conditions
                    </a>
                </div>
                <FooterCopyright>
                BDO Unibank, Inc. © 2015. All Rights Reserved
                </FooterCopyright> 
                <VersionText>{DEV_REV}</VersionText>       
                </FooterContainer> 

                        </Col>

                    </Row>   

        <Row className="d-block d-sm-none">
		<Col xs={12} sm={12}>
        <FooterSMDiv>
            <Row>
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>               
                    <a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
                        <span style={{color:'white'}}><FaHome/> Home</span>                        
                    </a>                       
                </Col>                    
                <Col style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <a href="https://www.bdo.com.ph/business" style={{padding:'10px'}}>
                        <span style={{color:'white'}}><FaMale/>Business Banking</span>                        
                    </a>        
                </Col>
            </Row>
            <Row>     
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <a href="https://www.bdo.com.ph/mobile/about-bdo">
                        <span style={{color:'white'}}>About</span>                        
                    </a>                        
                </Col>           
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <a href="https://www.bdo.com.ph/mobile/contact-us">
                        <span style={{color:'white'}}>Contact</span>                        
                    </a>                 
                </Col>           
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <a href="https://www.bdo.com.ph/mobile/terms-and-conditions">
                        <span style={{color:'white'}}>Terms</span>                        
                    </a>                 
                </Col>           
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <a href="https://www.bdo.com.ph/mobile/privacy-policy">
                        <span style={{color:'white'}}>Privacy</span>                        
                    </a>                 
                </Col>
            </Row>
            <Row> 
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>                    
                    <span style={{color:'white'}}>Desktop View</span>                                            
                </Col>               
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <a href="https://www.bdo.com.ph/mobile/forex">
                        <span style={{color:'white'}}>FOREX</span>                        
                    </a>                 
                </Col>
            </Row>
            <Row> 
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>                    
                    <a href="https://www.bdo.com.ph/mobile/personal/investments/daily-net-asset-value">
                        <span style={{color:'white'}}>Daily NAVPU</span>                        
                    </a>  
                </Col>               
                <Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
                    <span style={{color:'white'}}>
                    BDO Unibank © 2015    
                    </span>               
                    
                </Col>                               
            </Row>            
        </FooterSMDiv>
        </Col>
        </Row> 
            
            
            </Col>
        </Row>                                        
        </MORSContainer>              
);

export default IndexLayout;